export const FEATURE_UPDATE = 'FEATURE_UPDATE';
export const FEATURE_IDENTIFY = 'FEATURE_IDENTIFY';
export const FEATURE_INITIALIZE = 'FEATURE_INITIALIZE';
export const FEATURE_READY = 'FEATURE_READY';

export const update = (features = {}) => ({
  type: FEATURE_UPDATE,
  payload: features
});

export const identify = user => ({
  type: FEATURE_IDENTIFY,
  payload: user
});

export const initialize = (features = {}) => ({
  type: FEATURE_INITIALIZE,
  payload: features
});

export const ready = () => ({
  type: FEATURE_READY
});



// WEBPACK FOOTER //
// ./js/actions/feature.js